<span *ngFor="let label of shown" class="label-banner" [ngClass]="'label-banner--' + Labels[label]">
  {{ label | labelTranslate }}
</span>
